import { Mail, Shield } from "lucide-react";

// Iconos de marca eliminados de lucide-react v1 (motivos legales) — SVG inline
const LinkedinIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
    <rect x="2" y="9" width="4" height="12"/>
    <circle cx="4" cy="4" r="2"/>
  </svg>
);

const XIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.742l7.733-8.835L1.254 2.25H8.08l4.259 5.63L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z"/>
  </svg>
);

const Footer = ({ config, content }) => {
  const currentYear = new Date().getFullYear();
  
  const footerContent = content || {
    description: "Perito Informatico Colegiado especializado en analisis forense digital, certificacion de evidencias electronicas y peritajes judiciales en Madrid.",
    services_title: "Servicios",
    contact_title: "Contacto",
    legal_links: [
      { label: "Aviso Legal", href: "#" },
      { label: "Privacidad", href: "#" },
      { label: "Cookies", href: "#" }
    ]
  };

  return (
    <footer className="bg-slate-900 border-t border-slate-800 py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/logo.png"
                alt="Ciberperitaje Logo"
                className="h-8 w-auto"
              />
              <span className="font-outfit text-lg font-semibold text-white">
                ciberperito<span className="text-sky-400">forense</span>.es
              </span>
            </div>
            <p className="text-slate-500 text-sm leading-relaxed max-w-md mb-4">
              {footerContent.description}
            </p>
            <div className="flex items-center gap-2 text-sm text-slate-600">
              <Shield className="w-4 h-4 text-sky-400" />
              <span>Colegiado CPIICM {config?.cpiicm?.member_number || "XXXXX"}</span>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-outfit font-semibold text-white mb-4">{footerContent.services_title}</h4>
            <ul className="space-y-2">
              <li>
                <a href="#servicios" className="text-slate-500 hover:text-sky-400 text-sm transition-colors">
                  Forense de Dispositivos
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-slate-500 hover:text-sky-400 text-sm transition-colors">
                  Analisis de Comunicaciones
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-slate-500 hover:text-sky-400 text-sm transition-colors">
                  Ciberseguridad Legal
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-slate-500 hover:text-sky-400 text-sm transition-colors">
                  Nuevas Tecnologias
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-outfit font-semibold text-white mb-4">{footerContent.contact_title}</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href={`mailto:${config?.contact?.email || 'contacto@ciberperitoforense.es'}`}
                  className="text-slate-500 hover:text-sky-400 text-sm transition-colors flex items-center gap-2"
                >
                  <Mail className="w-4 h-4" />
                  {config?.contact?.email || 'contacto@ciberperitoforense.es'}
                </a>
              </li>
              <li className="text-slate-500 text-sm">
                {config?.contact?.location || 'Madrid, España'}
              </li>
            </ul>

            {/* Social links */}
            <div className="flex gap-3 mt-4">
              {config?.social?.linkedin && (
                <a 
                  href={config.social.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-sm bg-slate-800 border border-slate-700 flex items-center justify-center text-slate-500 hover:text-sky-400 hover:border-sky-400/50 transition-colors"
                  aria-label="LinkedIn"
                >
                  <LinkedinIcon className="w-4 h-4" />
                </a>
              )}
              {config?.social?.twitter && (
                <a 
                  href={config.social.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-sm bg-slate-800 border border-slate-700 flex items-center justify-center text-slate-500 hover:text-sky-400 hover:border-sky-400/50 transition-colors"
                  aria-label="X (Twitter)"
                >
                  <XIcon className="w-4 h-4" />
                </a>
              )}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-slate-600 text-sm">
              © {currentYear} ciberperitoforense.es. Todos los derechos reservados.
            </p>
            <div className="flex gap-6 text-sm">
              {footerContent.legal_links?.map((link, idx) => (
                <a key={idx} href={link.href} className="text-slate-600 hover:text-slate-400 transition-colors">
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
